import {NgIf} from '@angular/common';
import {CommonModule} from '@angular/common';
import {AfterViewInit, OnChanges, OnInit} from '@angular/core';
import {Component, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {finalize, tap} from "rxjs";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatFormFieldModule, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatAutocompleteModule, MatOption} from "@angular/material/autocomplete";
import {MatSelect, MatSelectModule} from "@angular/material/select";
import {OverlayContainer, OverlayModule} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import * as pdfGenerator from 'jspdf';
import JsBarcode from 'jsbarcode';
import {ChangeDetectorRef} from '@angular/core';

import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatNativeDateModule, MatOptionModule} from "@angular/material/core";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {CookieService} from "ngx-cookie-service";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {
    MatAccordion, MatExpansionModule,
    MatExpansionPanel,
    MatExpansionPanelDescription,
    MatExpansionPanelTitle
} from "@angular/material/expansion";
import * as XLSX from 'xlsx';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../environments/environment';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { AnalyseService } from '../../../services/analyse-service/analyse.service';
import { ClientsService } from '../../../services/client-service/clients.service';
import { HandleErrorsService } from '../../../services/handle-erros/handle.errors.service';
import { MatriceService } from '../../../services/matrice-service/matrice.service';
import { ParametreService } from '../../../services/parametre-service/parametre.service';
import { SampleService } from '../../../services/sample-service/sample.service';
import { SampleStatusService } from '../../../services/sample-status-service/sample.status.service';
import { TerrrainService } from '../../../services/terrains-service/terrrain.service';
import { TypeAnalyseService } from '../../../services/type-analyse-service/type.analyse.service';
import { DialogService } from '../../_modal/dialog.service';
import { ShortClientDto } from '../../_models/client.dtos';
import { ShortMatriceDto } from '../../_models/matrice.dtos';
import { ShortParametreDto } from '../../_models/parametre-dtos';
import { SampleStatusDto } from '../../_models/Sample.status.dto';
import { SampleDTO } from '../../_models/sampleDTO';
import { TerrainDTO } from '../../_models/terrain.dto';
import { ShortTypeAnalyseDto } from '../../_models/type.analyse.dtos';
import { ApiService } from '../../_services/api.service';
import { Endpoints } from '../../endpoints';
import { AppUserDTO } from '../../_models/userDTO';
import { UserService } from '../../../services/user-service/user.service';
import { MatChipsModule } from '@angular/material/chips';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MethodeStepService } from '../../../services/methodeS-service/methodeS.service';
import { MethodStepDTO } from '../../_models/method-step.dto';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@Component({
    selector: 'app-manage-users',
    standalone: true,
    providers: [TerrrainService,AnalyseService, ParametreService, TypeAnalyseService, ApiService, Endpoints, DialogService, MatriceService, UserService, HandleErrorsService, ClientsService, SampleStatusService],
    imports: [MatExpansionModule,MatRadioModule,
    MatNativeDateModule,
    CommonModule,MatOption,MatExpansionModule,
    MatNativeDateModule,
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    OverlayModule,
    MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,
    MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox, MatProgressSpinner, MatTab, MatTabGroup, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription,
    MatCardModule, MatMenuModule, MatButtonModule,MatButtonToggleModule, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,MatSlideToggleModule,
    MatSuffix, MatSortModule, MatInputModule, MatDatepickerToggle,MatDatepicker, MatDatepickerInput, MatCheckbox],
    templateUrl: './method-step.component.html',
    styleUrl: './method-step.component.scss'
})

export class MethodStepComponent implements OnInit{

  @ViewChild('content') content: TemplateRef<any>;

  form: FormGroup;
  loading = false;
  typeValeurOptions = [
    { id:1,value: 'NUMERIQUE', label: 'Numérique' },
    {id:2, value: 'TEXTE', label: 'Texte' },
    { id:3,value: 'BOOL', label: 'Booléen' }
  ];
  // Pour afficher dynamiquement les switches
  fieldConfigFields = [
    { key: 'valeurApplicable', label: 'Valeur' },
    { key: 'uniteApplicable', label: 'Unité' },
    { key: 'commentaireApplicable', label: 'Commentaire' },
    { key: 'dateApplicable', label: 'Date' },
    { key: 'statutApplicable', label: 'Statut' },
    { key: 'realiseApplicable', label: 'Réalisé' }
  ];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private methodeStepService: MethodeStepService,
    private dialogService: DialogService,
    private cookieService: CookieService,
    private sanitizer: DomSanitizer,
    private apiService: ApiService,
    private endpoints: Endpoints,
    public themeService: CustomizerSettingsService,
    private cdr: ChangeDetectorRef,
    private overlayContainer: OverlayContainer,
    private userService: UserService,
    private sampleService:SampleService,
    private handleErrors: HandleErrorsService
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    console.log('TypeValeur options:', this.typeValeurOptions);
    this.initializeForm();
    this.fetchSteps()
    console.log('FormGroup initialized:', this.form.value);
  }
  displayedColumns: string[] = [
    'select',
    'titre',
    'description',
    'valeurApplicable',
    'uniteApplicable',
    'commentaireApplicable',
    'dateApplicable',
    'statutApplicable',
    'realiseApplicable',
    'action'
  ];
  initializeForm() {
    this.form = this.fb.group({
      id: [''],
      titre: ['', Validators.required],
      description: [''],

      fieldConfig: this.fb.group({
        valeurApplicable: [true],
        uniteApplicable: [true],
        commentaireApplicable: [false],
        dateApplicable: [false],
        statutApplicable: [false],
        realiseApplicable: [true]
      })
    });
    console.log('Form controls:', this.form.controls);
  }
    searchVal: string = ''
    dataSource: MatTableDataSource<MethodStepDTO> = new MatTableDataSource<MethodStepDTO>();

   applyFilter(event: Event) {
        this.searchVal = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchVal
    }


      viewStep(step: MethodStepDTO) {
    console.log('Visualiser Step', step);
  }

  editStep(step: MethodStepDTO) {
    console.log('Modifier Step', step);
  }

  deleteStep(step: MethodStepDTO) {
    console.log('Supprimer Step', step);
  }
selectedSteps: MethodStepDTO[] = [];
  isAllStepsSelected = false;
  

  toggleSelection(step: MethodStepDTO) {
    const index = this.selectedSteps.indexOf(step);
    if (index === -1) this.selectedSteps.push(step);
    else this.selectedSteps.splice(index, 1);
  }

  toggleSelectAll() {
    if (this.isAllStepsSelected) this.selectedSteps = [];
    else this.selectedSteps = [...this.dataSource.data];
    this.isAllStepsSelected = !this.isAllStepsSelected;
  }

  
  openCreateModal() {
    this.form.reset();
    this.initializeForm();
    console.log('Opening modal with form:', this.form.value);
    this.modalService.open(this.content, { size: 'lg' });
  }

saveMethodStep() {
  if (this.form.invalid) return;

  this.methodeStepService.createMethodStep(this.form.value)
    .subscribe({
      next: () => {
        this.modalService.dismissAll();
        // refresh table
      },
      error: (err) => {
        this.dialogService.openDangerAlert(err);
      }
    });
}
@ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
     loadingTable: boolean = true;
  fetchSteps(): void {
    this.loadingTable = true;
    console.log('🔹 Début du fetch des MethodSteps...');
    
    this.methodeStepService.getAllMethodSteps().subscribe({
      next: (steps) => {
        console.log('✅ MethodSteps reçus du backend:', steps);
        this.dataSource.data = steps;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.loadingTable = false;
        console.log('📊 Table mise à jour avec les MethodSteps');
      },
      error: (err) => {
        console.error('❌ Erreur lors de la récupération des MethodSteps:', err);
        this.loadingTable = false;
      }
    });
  }
}
